export const SkillsData = [
  {
    type: "Front-End",
    list: [
      {
        name: "ReactJS",
        icon: <i class="devicon-react-original colored"></i>
        },
      {
        name: "HTML5",
        icon: <i class="devicon-html5-plain colored"></i>
        },
      {
        name: "JavaScript",
        icon: <i class="devicon-javascript-plain colored"></i>
      },
      {
        name: "TypeScripts",
        icon: <i class="devicon-typescript-plain colored"></i>
      },
    ],
  },
  {
    type: "Other Skills",
    list: [
      {
        name: "Django",
        icon: <i class="devicon-django-plain colored"></i>
      },
      {
        name: "Bootstrap",
        icon: <i class="devicon-bootstrap-plain colored"></i>
      },
      {
        name: "Azure",
        icon: <i class="devicon-azure-plain colored"></i>
      },
    ],
  },
];